import { EmailIntakeMessage_Read } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class EmailIntakeMessage {
  constructor(
    private _subject: string,
    private _from_name: string,
    private _from_email: string,
    private _body: string,
    private _created_at: Dayjs,
  ) {}

  public static parse(proto: EmailIntakeMessage_Read) {
    return new EmailIntakeMessage(
      proto.subject,
      proto.from_name,
      proto.from_email,
      proto.body,
      dayjs(proto.created_at),
    );
  }

  public get subject() {
    return this._subject;
  }

  public get fromName() {
    return this._from_name;
  }

  public get fromEmail() {
    return this._from_email;
  }

  public get body() {
    return this._body;
  }

  public get createdAt() {
    return this._created_at;
  }
}
